/* ============================================================================
   SPYLT countdown — drift-free, timezone-safe, reflow-minimal, no-JS-safe.
   Self-contained module (IIFE, no globals). Drives the coming-soon section.

   Contract:
     <div data-countdown data-deadline="1784095200000"> ... </div>
   data-deadline is an ABSOLUTE instant as epoch milliseconds, resolved
   server-side in the store's timezone (a date string is still accepted as a
   fallback). Display is total HOURS : MINUTES : SECONDS (hours can exceed 24,
   matching the Figma comp).
   ============================================================================ */
(function () {
  "use strict";

  function initCountdown(root) {
    var raw = root.dataset.deadline;
    // Epoch ms from the server (store timezone); tolerate a date string too.
    var deadline = /^-?\d+$/.test(raw) ? Number(raw) : new Date(raw).getTime();
    if (isNaN(deadline) || deadline === 0) return; // invalid/blank → leave static markup

    var els = {
      hours: root.querySelector('[data-cd="hours"]'),
      minutes: root.querySelector('[data-cd="minutes"]'),
      seconds: root.querySelector('[data-cd="seconds"]'),
    };
    if (!els.hours || !els.minutes || !els.seconds) return;

    var wrap = root.parentElement;
    var expired = wrap ? wrap.querySelector(".countdown__expired") : null;
    var last = { hours: null, minutes: null, seconds: null };
    var timer = null;

    // Write only when the value changed → avoids needless reflow/repaint.
    function paint(key, value) {
      var str = String(value).padStart(2, "0");
      if (last[key] !== str) {
        els[key].textContent = str;
        last[key] = str;
      }
    }

    function showExpired() {
      paint("hours", 0);
      paint("minutes", 0);
      paint("seconds", 0);
      root.hidden = true;
      if (expired) expired.hidden = false;
    }

    function tick() {
      var remaining = deadline - Date.now(); // recompute each tick → cannot drift
      if (remaining <= 0) {
        showExpired();
        return; // stop scheduling
      }
      var totalSec = Math.floor(remaining / 1000);
      paint("hours", Math.floor(totalSec / 3600)); // total hours, may exceed 24
      paint("minutes", Math.floor((totalSec % 3600) / 60));
      paint("seconds", totalSec % 60);

      // Self-correcting: align to the next whole-second boundary (no drift).
      timer = setTimeout(tick, 1000 - (Date.now() % 1000));
    }

    // Pause when tab hidden (saves battery/INP); re-sync on return.
    document.addEventListener("visibilitychange", function () {
      if (timer) clearTimeout(timer);
      if (!document.hidden) tick();
    });

    tick();
  }

  function boot() {
    var nodes = document.querySelectorAll("[data-countdown]");
    for (var i = 0; i < nodes.length; i++) initCountdown(nodes[i]);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
